module.exports = __webpack_public_path__ + "static/media/3_file_import_requirements_and_best_practices.62a7a2d8.png";